import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
// @ts-ignore
import styles from './torneio_arenamajubarretos.module.scss';

const WHATSAPP_NUMBER = '5516991414590';
const TORNEIO_TITULO = 'Torneio';
const INSCRICAO = 'Inscrição R$ 200,00 a dupla com uniforme';

type CategoriaTorneio = {
    id: string;
    nome: string;
    data: string;
    inicio: string;
    vagas: string;
    vagasLimitadas?: string;
    premios: string[];
};

const CATEGORIAS_06: CategoriaTorneio[] = [
    {
        id: 'principiante-0606',
        nome: 'Principiante',
        data: '06/06',
        inicio: '08:00HS',
        vagas: '20 vagas',
        vagasLimitadas: 'Vagas limitadas',
        premios: ['1º lugar R$ 350', '2º lugar R$ 250', '3º lugar R$ 100', '4º lugar Troféu'],
    },
    {
        id: 'iniciante-0606',
        nome: 'Iniciante',
        data: '06/06',
        inicio: '14:00HS',
        vagas: '20 vagas',
        vagasLimitadas: 'Vagas limitadas',
        premios: ['1º lugar R$ 450', '2º lugar R$ 300', '3º lugar R$ 150', '4º lugar Troféu'],
    },
];

const CATEGORIAS_07: CategoriaTorneio[] = [
    {
        id: 'misto-iniciante-0706',
        nome: 'Misto Iniciante',
        data: '07/06',
        inicio: '08:00HS',
        vagas: '20 vagas',
        vagasLimitadas: 'Vagas limitadas',
        premios: ['1º lugar R$ 500', '2º lugar R$ 350', '3º lugar R$ 150', '4º lugar Troféu'],
    },
    {
        id: 'amador-c-com-b-0706',
        nome: 'Amador C com B',
        data: '07/06',
        inicio: '14:00HS',
        vagas: '20 vagas',
        vagasLimitadas: 'Vagas limitadas',
        premios: ['1º lugar R$ 1100', '2º lugar R$ 500', '3º lugar R$ 300', '4º lugar Troféu'],
    },
];

function buildWhatsAppUrl(categoria: CategoriaTorneio) {
    const msg =
        `Olá! Gostaria de me inscrever no ${TORNEIO_TITULO}. ` +
        `Data: ${categoria.data}. ` +
        `Categoria: ${categoria.nome}. ` +
        `Início: ${categoria.inicio}. ` +
        `${INSCRICAO}.`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
}

const Torneio_arenamajubarretos: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.torneio_arenamajubarretos}>
            <div className={styles.inner}>
                <div className={styles.header}>
                    <Link to="/arenamajubarretos" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h1 className={styles.title}>{TORNEIO_TITULO}</h1>
                </div>

                <div className={styles.hero}>
                    <img
                        className={styles.heroImg}
                        src={require('./src/torneio-06.png')}
                        alt="Cartaz do torneio — dia 06/06"
                        loading="lazy"
                    />
                </div>

                <div className={styles.dayBlock} aria-label="Categorias do dia 06/06">
                    {CATEGORIAS_06.map((cat) => (
                        <div key={cat.id} className={styles.section}>
                            <div className={styles.sectionHeader}>
                                <h2 className={styles.sectionTitle}>{cat.nome}</h2>
                                <p className={styles.sectionInscricao}>{INSCRICAO}</p>
                            </div>
                            <div className={styles.metaRow}>
                                <span className={styles.metaItem}>Data: {cat.data}</span>
                                <span className={styles.metaItem}>Início: {cat.inicio}</span>
                                <span className={styles.metaItem}>{cat.vagas}</span>
                                <span className={styles.metaItem}>{cat.vagasLimitadas ?? 'Vagas limitadas'}</span>
                            </div>
                            <ul className={styles.premiosList}>
                                {cat.premios.map((linha, i) => (
                                    <li key={i}>{linha}</li>
                                ))}
                            </ul>
                            <a
                                href={buildWhatsAppUrl(cat)}
                                className={styles.cta}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                WhatsApp — {cat.nome} ({cat.data})
                            </a>
                        </div>
                    ))}
                </div>

                <div className={styles.hero}>
                    <img
                        className={styles.heroImg}
                        src={require('./src/torneio-07.png')}
                        alt="Cartaz do torneio — dia 07/06"
                        loading="lazy"
                    />
                </div>

                <div className={styles.dayBlock} aria-label="Categorias do dia 07/06">
                    {CATEGORIAS_07.map((cat) => (
                        <div key={cat.id} className={styles.section}>
                            <div className={styles.sectionHeader}>
                                <h2 className={styles.sectionTitle}>{cat.nome}</h2>
                                <p className={styles.sectionInscricao}>{INSCRICAO}</p>
                            </div>
                            <div className={styles.metaRow}>
                                <span className={styles.metaItem}>Data: {cat.data}</span>
                                <span className={styles.metaItem}>Início: {cat.inicio}</span>
                                <span className={styles.metaItem}>{cat.vagas}</span>
                                <span className={styles.metaItem}>{cat.vagasLimitadas ?? 'Vagas limitadas'}</span>
                            </div>
                            <ul className={styles.premiosList}>
                                {cat.premios.map((linha, i) => (
                                    <li key={i}>{linha}</li>
                                ))}
                            </ul>
                            <a
                                href={buildWhatsAppUrl(cat)}
                                className={styles.cta}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                WhatsApp — {cat.nome} ({cat.data})
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Torneio_arenamajubarretos;
